import { Reducer } from 'react';

export interface IHttpClientReducerState<T> {
  loading: boolean;
  data: T | null;
  error: string[];
}

export enum EReducerActions {
  RESET,
  SUCCESS,
  WITH_WARNING,
  REQUEST_FAILED,
}

export interface ISuccessPayload<T> {
  data: T;
}

export interface IErrorPayload<T> {
  data: T;
  error: string[];
}

export type Actions<T> =
  | { actionType: EReducerActions.RESET }
  | { actionType: EReducerActions.SUCCESS; payload: ISuccessPayload<T> }
  | { actionType: EReducerActions.WITH_WARNING; payload: IErrorPayload<T> }
  | { actionType: EReducerActions.REQUEST_FAILED };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type HttpClientReducer<T = any> = Reducer<IHttpClientReducerState<T>, Actions<T>>;
